import React, { Fragment, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { Image, Button, Modal } from 'react-bootstrap';
import Switch from 'react-switch';
import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox';
import SuperAdminDeleteOffer from '../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteOffer';
import {
  Toggle,
  DisabledToggle,
} from '../../../superAdminReusable/reusableSuperAdminButton/Toggle';
import Alert from 'react-s-alert';
import moment from 'moment';
// import { EVENT_DETAILS_ADMIN } from "../../../../store/types";
import { useDispatch } from 'react-redux';
import SlidingComponent from '../../../../reusableComponents/slidingToggleComponent/SlidingComponent';
import ShareLinkModal from '../../../../reusableComponents/ShareLinkModal';

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: 'linear',
    overlayColor: 'rgba(0, 0, 0, 0.9)',
    slideAnimationType: 'fade',
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: 'linear',
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

export const SuperAdminRestaurantTableBody = (props) => {
  //state
  const history = useHistory();
  const dispatch = useDispatch();
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  //const [checked, setChecked] = useState(false);
  // const toggleFunction = (e) => {
  //   setChecked({ checked: !checked.checked });
  // };
  const [showDeleteOffer, seShowDeleteOffer] = useState(false);

  const handleCloseDeleteOffer = () => {
    seShowDeleteOffer(false);
  };

  const mainCrouselChangeHandler = (e, offer) => {
    var d1 = new Date();
    var d2 = new Date(offer.end_date);
    var notSame = d2.getTime() < d1.getTime();
    if (notSame === true && offer.send_to_carousel === false) {
      Alert.error(
        `<h4>Offer is expired so you can not perform this action</h4>`,
        {
          position: 'top-right',
          effect: 'bouncyflip',
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        }
      );
    } else if (notSame === true && offer.send_to_carousel === true) {
      props.onChangeToogleStatus(
        props.offer.send_to_carousel,
        props.offer._id,
        'carousel'
      );
    } else {
      props.onChangeToogleStatus(
        props.offer.send_to_carousel,
        props.offer._id,
        'carousel'
      );
    }
  };

  return (
    <Fragment>
      <tbody key={props.keys}>
        <tr className="super_admin_all_users_table_body mt-3">
          <td colSpan="7" className="p-0 w-100">
            <table className="w-100 HideShowTable">
              <tbody>
                <tr className="cursor" onClick={showTr}>
                  <td style={{ width: '11%' }}>
                    <div className="super-admin-suggestion-table-body-boxone d-flex align-items-center">
                      <div
                        className="super-admin-suggestion-imageBoxOne enIMG33"
                        onClick={(e) => {
                          if (!e) var e = window.event;
                          e.cancelBubble = true;
                          if (e.stopPropagation) e.stopPropagation();
                        }}
                      >
                        <SimpleReactLightbox>
                          <SRLWrapper options={options}>
                            <img
                              src={props?.offer?.restaurant_id?.logo_url}
                              alt="Icon"
                              className="img-fluid rounded-circle"
                            />
                          </SRLWrapper>
                        </SimpleReactLightbox>
                      </div>
                      <div className="super-admin-suggestion-imageBoxTwo ml-2">
                        <div className="f12-500">
                          {props?.offer?.restaurant_id?.restaurant_name}
                        </div>
                        <div className="f9-400 mt-2">
                          {props?.offer?.venue_address}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: '18%' }}>
                    <div className="d-flex align-items-center">
                      <div
                        className="text-center d-flex flex-column align-items-center"
                        style={{ width: '30%' }}
                        onClick={(e) => {
                          if (!e) var e = window.event;
                          e.cancelBubble = true;
                          if (e.stopPropagation) e.stopPropagation();
                        }}
                      >
                        <SimpleReactLightbox>
                          <SRLWrapper options={options}>
                            <Image
                              //src={require("../../../../assets/images/UserManagement/offer.png")}
                              src={
                                props &&
                                props.offer &&
                                props.offer.photos &&
                                props.offer.photos[0]
                              }
                              alt="offer image"
                              title="offer image"
                              style={{
                                borderRadius: '5px',
                                width: '53px',
                                height: '53px',
                              }}
                              fluid
                            />
                          </SRLWrapper>
                        </SimpleReactLightbox>
                        {props.offer && props.offer.isOnline ? (
                          <div
                            style={{
                              backgroundColor: '#06a200',
                              color: '#ffffff',
                              borderRadius: '50px',
                            }}
                            className="px-3 py-1 mt-2 f10-500"
                          >
                            Online
                          </div>
                        ) : (
                          <div
                            style={{
                              backgroundColor: '#f0b900',
                              color: '#ffffff',
                              borderRadius: '50px',
                            }}
                            className="px-3 py-1 mt-2 f10-500"
                          >
                            Offline
                          </div>
                        )}
                      </div>
                      <div className="pl-3">
                        <div className="f12-500 mb-2">
                          {props && props.offer && props.offer.name}
                        </div>
                        <div className="f9-400 text-break">
                          #{props && props.offer && props.offer._id}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: '8%' }} className="text-center">
                    <div className="f12-500">
                      {' '}
                      {moment(props.offer.start_date).format('Do MMM YY')}
                    </div>
                    <div className="f12-500 mt-2 mb-2">to</div>
                    <div className="f12-500 text-red">
                      {' '}
                      {moment(props.offer.end_date).format('Do MMM YY')}
                    </div>
                  </td>
                  <td style={{ width: '10%' }}>
                    <p className="f10-500">
                      {props?.offer?.isOnline
                        ? props?.offer?.isPercentage
                          ? 'Percentage'
                          : 'Fixed Amount'
                        : '_'}
                    </p>
                  </td>
                  <td style={{ width: '10%' }}>
                    <p className="f10-500">
                      {props?.offer?.isOnline
                        ? props?.offer?.isPercentage
                          ? props?.offer?.discount
                          : '-'
                        : '-'}
                    </p>
                  </td>
                  <td style={{ width: '10%' }}>
                    <p className="f10-400">
                      {props?.offer?.isOnline
                        ? !props?.offer?.isPercentage
                          ? props?.offer?.discount
                          : '-'
                        : '-'}
                    </p>
                  </td>
                  <td
                    style={{ width: '10%' }}
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    <p className="f10-400 mb-3">
                      {props?.offer?.send_to_carousel ? 'Active' : 'Inactive'}
                    </p>
                    <SlidingComponent
                      name="carousel_status"
                      currentState={props?.offer?.send_to_carousel}
                      type={'checkbox'}
                      toggleclass={
                        'toggle vendor-super-admin-toggle d-flex align-items-center'
                      }
                      toggleinputclass={
                        'toggle__switch vendor-super-admin-toggle'
                      }
                      onChange={(e) => mainCrouselChangeHandler(e, props.offer)}
                      // slidingonClick={this.onSelecttogglestatusChange(data)}
                      defaultChecked={
                        props?.offer?.send_to_carousel ? true : false
                      }
                    />
                  </td>
                  <td
                    style={{ width: '10%' }}
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    <p className="f10-400 mb-3">
                      {props?.offer?.active ? 'Active' : 'Inactive'}
                    </p>
                    <Switch
                      checked={props?.offer?.active}
                      onChange={() => {}}
                      onColor="#EEEEEE"
                      offHandleColor="#212121"
                      onHandleColor="#59F832"
                      handleDiameter={24} //19
                      uncheckedIcon={false}
                      checkedIcon={false}
                      offColor="#bcbcbc"
                      boxShadow="-2px 0px 5px #0000003B"
                      activeBoxShadow="-2px 0px 5px #0000003B"
                      height={15} //22
                      width={41} //45
                      id="disabled-switch"
                      disabled={true}
                    />
                    {/* <SlidingComponent
                      name="active_status"
                      currentState={props?.offer?.active}
                      type={"checkbox"}
                      toggleclass={
                        "toggle vendor-super-admin-toggle d-flex align-items-center"
                      }
                      toggleinputclass={
                        "toggle__switch vendor-super-admin-toggle"
                      }
                      onChange={() => {}}
                      disabled={true}
                      // slidingonClick={this.onSelecttogglestatusChange(data)}
                      defaultChecked={props?.offer?.active ? true : false}
                    /> */}
                  </td>
                  <td
                    style={{ width: '10%' }}
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                    className="d-flex align-items-center justify-content-between"
                  >
                    <p
                      className={`${
                        props?.offer?.mark_as_primary ? 'f10-400' : 'f10-500 '
                      }`}
                    >
                      No
                    </p>
                    <Switch
                      checked={props?.offer?.mark_as_primary}
                      onChange={() => {}}
                      onColor="#EEEEEE"
                      offHandleColor="#212121"
                      onHandleColor="#59F832"
                      handleDiameter={24} //19
                      uncheckedIcon={false}
                      checkedIcon={false}
                      offColor="#bcbcbc"
                      boxShadow="-2px 0px 5px #0000003B"
                      activeBoxShadow="-2px 0px 5px #0000003B"
                      height={15} //22
                      width={41} //45
                      id="disabled-switch"
                      disabled={true}
                    />
                    <p
                      className={`${
                        props?.offer?.mark_as_primary ? 'f10-500' : 'f10-400 '
                      }`}
                    >
                      Yes
                    </p>
                  </td>
                </tr>
                {TrDetail.TrDetail && (
                  <tr className="border-top">
                    <td style={{ width: '18%' }}>
                      <div className="f12-500 text-red mb-3">More details</div>
                      <div className="d-flex align-items-center border-right">
                        {/* <SuperAdminDeleteoffer /> */}
                        <SuperAdminDeleteOffer
                          offerId={props.offer && props.offer._id}
                        />
                        <Button
                          variant="link"
                          className="enIconBtn mr-3"
                          onClick={
                            props?.offer?.isOnline
                              ? () => props.handleShowView(props.offer)
                              : () => props.handleShowView2(props.offer)
                          }
                        >
                          <Image
                            src={require('../../../../../assets/images/UserManagement/eye.svg')}
                            alt="View"
                            title="View"
                            fluid
                          />
                        </Button>
                        <Button
                          variant="link"
                          className="enIconBtn mr-3"
                          onClick={
                            props?.offer?.isOnline
                              ? () => props.handleEditShow(props.offer)
                              : () => props.handleEditShow2(props.offer)
                          }
                        >
                          <Image
                            src={require('../../../../../assets/images/UserManagement/pencil.svg')}
                            alt="Edit Offer"
                            title="Edit Offers"
                            fluid
                          />
                        </Button>
                        <ShareLinkModal
                          userAppLink={props.offer?.shareLink?.shortLink || ''}
                          webAppHide={true}
                        />
                        {/* <NavLink
                          className="enIconBtn mr-3"
                          to={
                            props.offer.isOnline
                              ? `/superadminoffers/edit-online-offer/${props.offer._id}`
                              : `/superadminoffers/edit-offline-offer/${props.offer._id}`
                          }
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit offer"
                            title="Edit offer"
                            fluid
                          />
                        </NavLink> */}
                      </div>
                    </td>
                    <td style={{ width: '11%' }}></td>
                    <td style={{ width: '15%' }}>
                      <div className="f12-500 mb-3">Views</div>
                      <div className="f12-400 ">{props?.offer?.offerViews}</div>
                    </td>
                    <td style={{ width: '15%' }}>
                      <div className="f12-500 mb-3">Used</div>
                      <div className="f12-400 enEllips">
                        {props?.offer?.offerUsed}
                      </div>
                    </td>
                    <td style={{ width: '10%' }}>
                      <div className="f12-500 mb-3">Offer Code</div>
                      <div className="f12-400 enEllips">
                        {props?.offer?.coupon_code}
                      </div>
                    </td>
                    <td style={{ width: '15%' }}>
                      <div className="f12-500 mb-3">Offer Code Usage Limit</div>
                      <div className="f12-400 enEllips">
                        {props?.offer?.maximum_usage_limit}
                      </div>
                    </td>
                    <td style={{ width: '15%' }}>
                      <div className="f12-500 mb-3">Applicable To Services</div>
                      <div className="d-flex align-items-center f12-400">
                        {props?.offer?.service_type.length <= 0
                          ? '-'
                          : props?.offer?.service_type.map((item, index) => {
                              if (index === 0) {
                                return item;
                              } else if (item) {
                                return ', ' + item;
                              }
                            })}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
      <React.Fragment>
        <Modal show={showDeleteOffer} onHide={handleCloseDeleteOffer} centered>
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            Are you sure to Delete the offer ?
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={handleCloseDeleteOffer}
            >
              No
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              onClick={() => props.deleteOffer()}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    </Fragment>
  );
};

// import React, { useState } from "react";
// import { Image, Button } from "react-bootstrap";
// import { NavLink } from "react-router-dom";
// import Alert from "react-s-alert";
// import moment from "moment";

// import SuperAdminDeleteOffer from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteOffer";
// import {
//   Toggle,
//   DisabledToggle,
// } from "../../../superAdminReusable/reusableSuperAdminButton/Toggle";

// export const SuperAdminRestaurantTableBody = (props) => {
//   // const [checked, setChecked] = useState(false);
//   // // const [checked, setChecked] = useState(false);
//   // // const [checked, setChecked] = useState(false);
//   // const toggleFunction = (e) => {
//   //   setChecked({ checked: !checked.checked });
//   // };

// const mainCrouselChangeHandler = (e, offer) => {
//   var d1 = new Date();
//   var d2 = new Date(offer.end_date);
//   var notSame = d2.getTime() < d1.getTime();
//   if (notSame === true && offer.send_to_carousel === false) {
//     Alert.error(
//       `<h4>Offer is expired so you can not perform this action</h4>`,
//       {
//         position: "top-right",
//         effect: "bouncyflip",
//         beep: true,
//         html: true,
//         timeout: 3000,
//         offset: 35,
//       }
//     );
//   } else if (notSame === true && offer.send_to_carousel === true) {
//     props.onChangeToogleStatus(
//       props.offer.send_to_carousel,
//       props.offer._id,
//       "carousel"
//     );
//   } else {
//     props.onChangeToogleStatus(
//       props.offer.send_to_carousel,
//       props.offer._id,
//       "carousel"
//     );
//   }
// };

//   return (
//     <React.Fragment>
//       <tbody>
//         <tr className="super_admin_all_users_table_body">
//           <td style={{ width: 130 }}>
//             <div className="d-flex flex-column align-items-start">
//               <div className="d-flex flex-column align-items-center justify-content-center">
//                 <div className="enImage45">
//                   <Image
//                     // src={require("../../../../../assets/images/UserManagement/fhr7.png")}
//                     src={
//                       props.offer &&
//                       props.offer.restaurant_id &&
//                       props.offer.restaurant_id.logo_url
//                     }
//                     alt="restaurant logo"
//                     title="restaurant logo"
//                     fluid
//                     width="100%"
//                     height="100%"
//                   />
//                 </div>
//                 <div className="f11-500 text-center mt-1">
//                   {props.offer &&
//                     props.offer.restaurant_id &&
//                     props.offer.restaurant_id.restaurant_name}
//                 </div>
//               </div>
//             </div>
//           </td>
//           <td style={{ width: 250 }}>
//             <div className="d-flex align-items-center">
//               <div className="text-center d-flex flex-column align-items-center">
//                 <div className="enIMG62">
//                   <Image
//                     // src={require("../../../../../assets/images/UserManagement/offer.png")}
//                     src={props.offer && props.offer.photos[0]}
//                     alt="offer img"
//                     title="offer img"
//                     fluid
//                     className="w-100 h-100"
//                   />
//                 </div>
//                 <div className="enPendingLBL mt-2">Offline</div>
//               </div>
//               <div className="pl-3">
//                 <div className="f12-500">{props.offer && props.offer.name}</div>
//                 <div className="f10-500 opacity5">Avail Offer on All Items</div>
//               </div>
//             </div>
//           </td>
//           <td style={{ width: 130 }}>
//             <div className="f15-700">
//               {props.offer && props.offer.coupon_code}
//             </div>
//           </td>
//           <td style={{ width: 140 }}>
//             <div className="f12-500">
//               {" "}
//               {moment(props.offer && props.offer.start_date).format(
//                 "Do MMM, YY"
//               )}
//             </div>
//             <div className="f12-500 pl-4 py-1">to</div>
//             <div className="f12-500 text-red">
//               {" "}
//               {moment(props.offer && props.offer.end_date).format("Do MMM, YY")}
//             </div>
//           </td>
//           <td style={{ width: 85 }}>
//             <div className="f15-700 mb-2">
//               {props.offer && props.offer.offerViews}
//             </div>
//             <div className="f15-700">
//               {props.offer && props.offer.offerUsed}
//             </div>
//           </td>
//           <td style={{ width: 120 }}>
//             <span className="f15-700">25</span>
//           </td>
//           <td style={{ width: 130 }}>
//             <span className="f15-700">Percentage</span>
//           </td>
//           <td style={{ width: 130 }}>
//             <span className="f15-700">10</span>
//           </td>
//           <td style={{ width: 130 }}>
//             <span className="f15-700">-</span>
//           </td>
//           <td style={{ width: 120 }}>
//             <span className="f15-700">Curb Side, Take Away</span>
//           </td>
//           <td style={{ width: 90 }}>
//             <Toggle
//               checked={props.offer && props.offer.send_to_carousel}
//               //toggleFunction={toggleFunction}
//               toggleFunction={(e) => mainCrouselChangeHandler(e, props.offer)}
//             />
//           </td>
//           <td style={{ width: 90 }}>
//             {" "}
//             <DisabledToggle
//               checked={props.offer && props.offer.mark_as_primary}
//               // toggleFunction={() =>
//               //   props.onChangeToogleStatus(
//               //     props.offer.mark_as_primary,
//               //     props.offer._id,
//               //     "primary"
//               //   )
//               // }
//             />
//           </td>
//           <td style={{ width: 90 }}>
//             {" "}
//             {/* <DisabledToggle
//               checked={props.offer && props.offer.active}
//               // toggleFunction={() =>
//               //   props.onChangeToogleStatus(
//               //     props.offer.active,
//               //     props.offer._id,
//               //     "status"
//               //   )
//               // }
//             /> */}
//           </td>
//           <td style={{ width: "217px" }}>
//             <div className="d-flex">
//               <SuperAdminDeleteOffer offerId={props.offer && props.offer._id} />
//               <Button
//                 variant="link"
//                 className="enIconBtn mr-3"
//                 onClick={() => props.handleShowView(props.offer._id)}
//               >
//                 <Image
//                   src={require("../../../../../assets/images/UserManagement/eye.svg")}
//                   alt="View offer"
//                   title="View offer"
//                   fluid
//                 />
//               </Button>
//               <NavLink
//                 className="enIconBtn mr-3"
//                 to={`/superadminoffers/edit-offline-offer/${props.offer._id}`}
//               >
//                 <Image
//                   src={require("../../../../../assets/images/UserManagement/pencil.svg")}
//                   alt="Edit offer"
//                   title="Edit offer"
//                   fluid
//                 />
//               </NavLink>
//             </div>
//           </td>
//         </tr>
//       </tbody>
//       {/* <tbody>
//         <tr className="super_admin_all_users_table_body">
//           <td style={{ width: 130 }}>
//             <div className="d-flex flex-column align-items-start">
//               <div className="d-flex flex-column align-items-center justify-content-center">
//                 <div className="enImage45">
//                   <Image
//                     src={require("../../../../../assets/images/UserManagement/fhr7.png")}
//                     alt="View"
//                     title="View"
//                     fluid
//                     width="100%"
//                     height="100%"
//                   />
//                 </div>
//                 <div className="f11-500 text-center mt-1">McDonald</div>
//               </div>
//             </div>
//           </td>
//           <td style={{ width: 250 }}>
//             <div className="d-flex align-items-center">
//               <div className="text-center d-flex flex-column align-items-center">
//                 <Image
//                   src={require("../../../../../assets/images/UserManagement/offer.png")}
//                   alt="View"
//                   title="View"
//                   fluid
//                 />
//                 <div className="enSuccessLBL mt-2">Online</div>
//               </div>
//               <div className="pl-3">
//                 <div className="f12-500">Buy 1 Get 1 Free</div>
//                 <div className="f10-500 opacity5">Avail Offer on All Items</div>
//               </div>
//             </div>
//           </td>
//           <td style={{ width: 130 }}>
//             <div className="f15-700">NS2198</div>
//           </td>
//           <td style={{ width: 140 }}>
//             <div className="f12-500"> 25th Mar 20</div>
//             <div className="f12-500 pl-4 py-1">to</div>
//             <div className="f12-500 text-red"> 28th Mar 20</div>
//           </td>
//           <td style={{ width: 85 }}>
//             <div className="f15-700 mb-2">20</div>
//             <div className="f15-700">15</div>
//           </td>
//           <td style={{ width: 120 }}>
//             <span className="f15-700">25</span>
//           </td>
//           <td style={{ width: 130 }}>
//             <span className="f15-700">Percentage</span>
//           </td>
//           <td style={{ width: 130 }}>
//             <span className="f15-700">10</span>
//           </td>
//           <td style={{ width: 130 }}>
//             <span className="f15-700">-</span>
//           </td>
//           <td style={{ width: 120 }}>
//             <span className="f15-700">Curb Side, Take Away</span>
//           </td>
//           <td style={{ width: 90 }}>
//             <Toggle checked={checked.checked} toggleFunction={toggleFunction} />
//           </td>
//           <td style={{ width: 90 }}>
//             {" "}
//             <Toggle checked={checked.checked} toggleFunction={toggleFunction} />
//           </td>
//           <td style={{ width: 90 }}>
//             {" "}
//             <Toggle checked={checked.checked} toggleFunction={toggleFunction} />
//           </td>
//           <td style={{ width: "217px" }}>
//             <div className="d-flex">
//               <SuperAdminDeleteOffer />
//               <Button
//                 variant="link"
//                 className="enIconBtn mr-3"
//                 onClick={props.handleShowView2}
//               >
//                 <Image
//                   src={require("../../../../../assets/images/UserManagement/eye.svg")}
//                   alt="Edit"
//                   title="Edit"
//                   fluid
//                 />
//               </Button>
//               <NavLink
//                 className="enIconBtn mr-3"
//                 to="/superadminoffers/edit-online-offer"
//               >
//                 <Image
//                   src={require("../../../../../assets/images/UserManagement/pencil.svg")}
//                   alt="Edit"
//                   title="Edit"
//                   fluid
//                 />
//               </NavLink>
//             </div>
//           </td>
//         </tr>
//       </tbody> */}
//     </React.Fragment>
//   );
// };
